import request from '../request'

export function card_order_create(data) {
  return request({
    url: '/va/card/order/create',
    method: 'post',
    data,
  })
}
